module.exports = __webpack_public_path__ + "media/images/projects/project_banner-cbccb844a59fec5c1c878b58831b0a9d.jpg";